import { Building2, Code2, Rocket } from 'lucide-react'
import { LandingSection } from './LandingSection'

const useCases = [
  {
    icon: Rocket,
    title: 'SaaS teams',
    description:
      'Watch production, staging, and billing endpoints. Share a public status page and get Slack or email alerts before support tickets pile up.',
  },
  {
    icon: Building2,
    title: 'Agencies',
    description:
      'Monitor client sites from one dashboard. Status pages and alerts give your team a shared view of what is down.',
  },
  {
    icon: Code2,
    title: 'API owners',
    description:
      'Health-check REST endpoints with POST requests, auth headers, and realistic user agents. Track SSL expiry too.',
  },
]

export function LandingUseCases() {
  return (
    <LandingSection
      id="use-cases"
      title="Built for SaaS teams, agencies, and API owners"
      subtitle="Whether you run one product or dozens of client sites, Pingscalate keeps watch while you ship."
    >
      <ul className="grid gap-6 md:grid-cols-3">
        {useCases.map((item) => (
          <li key={item.title} className="rounded-xl border border-border bg-surface/40 p-6">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-status-up/15">
              <item.icon className="h-5 w-5 text-status-up" aria-hidden />
            </div>
            <h3 className="mt-4 text-lg font-semibold text-text-primary">{item.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-text-secondary">{item.description}</p>
          </li>
        ))}
      </ul>
    </LandingSection>
  )
}
